import React, { lazy } from 'react'
import "./zartecbutton.css"
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';
import img1 from '../Components/Images/Barcode/scanner/LS2208.jpg'
import img2 from '../Components/Images/Barcode/scanner/DS8100.jpg'
import img3 from '../Components/Images/Barcode/scanner/xenon-general.avif'
import img4 from '../Components/Images/Barcode/scanner/granit.webp'
import img5 from '../Components/Images/Barcode/scanner/li3600.jpg'
import img6 from '../Components/Images/Barcode/scanner/xenon-health.avif'
import img7 from '../Components/Images/Barcode/scanner/DS8178.jpg'



function BarcodeScanners() {
  const productGeneral=[
    {
    id:1,
    category:"LS2208 ID Scanner -Zebra",
    model:"LS2208",
    description: "Captures Virtually All 1D Barcodes on Any Surface Built on the best-selling LS2208, linear corded imager delivers enhanced features such as support for mobile barcodes for unparalleled 1D barcode scanning. ",
    image: img1
  },
  {
    id:2,
    category:"DS8100 1D/2D scanners - Zebra",
    model:"ZD200",
    description: "The Ultimate in Performance, Innovation and Manageability Featuring unparalleled performance on virtually every barcode, superior scan range and swappable power options. ",
    image: img2
  },
  {
    id:3,
    category:"Xenon XP 1952 battery free scanner - Honeywell",
    model:"Xenon XP 1952",
    description: "The Honeywell Xenon™ Extreme Performance (XP) 1952g-bf area-imager scanner is Honeywell’s latest barcode scanner powered by supercapacitors – eliminating the battery.",
    image: img3
  }
  
];

const productHealth =[
  {
    id:1,
    category:"Xenon XP 1952h healthcare battery free",
    description:" It’s capable of achieving a full charge in under 60 seconds, putting the power of accurate patient care back in the caregiver's hands. ",
    image:img6
  },
  {
    id:2,
    category:"DS8178 - HC",
    description:"The ability to instantly capture the most difficult to read barcodes, an industry-leading housing that helps offer maximum protection against the spread of bacteria, Night Mode with Vibrate for can’t miss feedback on decodes",
    image:img7
  }
  
]

const productRugged =[
  {
    id:1,
    category:"Granit XP 1990 i XLR ",
    description:"The Granit™ XP 1990iXLR is designed to offer premium scanning performance and full range scanning depth to drive efficiency and reliability in mission-critical applications. ",
    image:img4
  },
  {
    id:2,
    category:"LI3600 ultra rugged",
    description:"The Simplicity Of A Scanner, The Versatility To Do More. These scanners stand up to harsh conditions, read at astonishing lengths and speeds, and give workers nonstop, full-shift power.",
    image:img5
  }
]
  return (
    <div>
      <section>
    <Container className="py-5">
      <h2 className="mb-4 cijh2">General Purpose handheld scanners</h2>
      <Row>
        {productGeneral.map(product => (
          <Col lg={4} md={6} className="mb-4" key={product.id}>
            <Card className="h-100 border-light shadow-sm rounded-3">
              <div className="p-3 text-center">
                <img src={product.image} alt={product.model} className="img-fluid" style={{ maxHeight: '200px' }} onLoad={lazy} />
              </div>
              <Card.Body className="d-flex flex-column">
                <div className=" mb-2" 
                style={{
                  background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  fontFamily:"Poppins",
                  color: "transparent",
                  fontWeight :"bold",
                  display: "inline-flex",
                  alignItems: "center",
                  textDecoration: "none",
                  marginTop: "auto",
                }}>
                  {product.category}</div>
                
                <p className="text-muted" style={{fontFamily:"sans-serif"}}>{product.description}</p>
                
                <Link to={product.productlink}>
                <button 
                  className={`zartec-btn zartec-btn-primary zartec-btn-small`} 
                  
                  >
                  Get Product
                  </button>
                  </Link>
              </Card.Body>
              
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
    </section>

    <section>
    <Container className="py-5">
      <h2 className="mb-4 cijh2">Rugged handheld scanners</h2>
      <Row>
        {productRugged.map(product => (
          <Col lg={4} md={6} className="mb-4" key={product.id}>
            <Card className="h-100 border-light shadow-sm rounded-3">
              <div className="p-3 text-center">
                <img src={product.image} alt={product.model} className="img-fluid" style={{ maxHeight: '200px' }} />
              </div>
              <Card.Body className="d-flex flex-column">
                <div className=" mb-2" 
                style={{
                  background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  fontFamily:"Poppins",
                  color: "transparent",
                  fontWeight :"bold",
                  display: "inline-flex",
                  alignItems: "center",
                  textDecoration: "none",
                  marginTop: "auto",
                }}>
                  {product.category}</div>
                
                <p className="text-muted" style={{fontFamily:"sans-serif"}}>{product.description}</p>
                
                <Link to={product.productlink}>
                <button 
                  className={`zartec-btn zartec-btn-primary zartec-btn-small`} 
                  
                  >
                  Get Product
                  </button>
                  </Link>
              </Card.Body>
              
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
    </section>

    <section>
    <Container className="py-5">
      <h2 className="mb-4 cijh2">Healthcare Scanners</h2>
      <Row>
        {productHealth.map(product => (
          <Col lg={4} md={6} className="mb-4" key={product.id}>
            <Card className="h-100 border-light shadow-sm rounded-3">
              <div className="p-3 text-center">
                <img src={product.image} alt={product.model} className="img-fluid" style={{ maxHeight: '200px' }} />
              </div>
              <Card.Body className="d-flex flex-column">
                <div className=" mb-2" 
                style={{
                  background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  fontFamily:"Poppins",
                  color: "transparent",
                  fontWeight :"bold",
                  display: "inline-flex",
                  alignItems: "center",
                  textDecoration: "none",
                  marginTop: "auto",
                }}>
                  {product.category}</div>
                
                <p className="text-muted" style={{fontFamily:"sans-serif"}}>{product.description}</p>
                
                <Link to={product.productlink}>
                <button 
                  className={`zartec-btn zartec-btn-primary zartec-btn-small`} 
                  
                  >
                  Get Product
                  </button>
                  </Link>
              </Card.Body>
              
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
    </section>
    </div>
  )
}

export default BarcodeScanners
